import {
  ID,
  lifeAreaOtherID,
  ReorderItem,
  ReorderResult,
  Task,
  TaskListItemTypes,
} from '@griply/types';
import cloneDeep from 'lodash/cloneDeep';

import { applyReorderTaskLinks } from './apply-reorder-task-links';
import { filterReorderableChildIds } from './filter-reorderable-child-ids';
import { findParentItem } from './find-parent-item';

export type OnLifeAreaReorderOptions = {
  updatedItems: readonly ReorderItem[];
  oldItems: readonly ReorderItem[];
  tasksMap: Record<ID, Task>;
  lifeAreaIds: readonly ID[];
};

export const onLifeAreaReorder = ({
  updatedItems,
  oldItems,
  tasksMap,
  lifeAreaIds,
}: OnLifeAreaReorderOptions): ReorderResult => {
  const updatedTasks: Task[] = [];
  const updatedSections: ReorderResult['updatedSections'] = [];
  const validSectionIds = new Set<ID>([...lifeAreaIds, lifeAreaOtherID]);

  updatedItems.forEach((item) => {
    if (item.type === TaskListItemTypes.Task) {
      if (!tasksMap[item.id]) {
        return;
      }

      const taskToUpdate = cloneDeep(tasksMap[item.id]);
      const newParentItem = findParentItem(updatedItems, item.id);
      const oldParentItem = findParentItem(oldItems, item.id);

      if (
        !newParentItem ||
        !oldParentItem ||
        newParentItem.id === oldParentItem?.id
      ) {
        return;
      }

      applyReorderTaskLinks({
        task: taskToUpdate,
        original: tasksMap[item.id],
        goalIds: [],
        lifeAreaIds: [newParentItem.id],
      });

      updatedTasks.push(taskToUpdate);
      return;
    }

    if (
      item.type === TaskListItemTypes.LifeArea &&
      validSectionIds.has(item.id)
    ) {
      updatedSections.push({
        id: item.id,
        taskSorting: filterReorderableChildIds(item.children),
      });
    }
  });

  return { updatedSections, updatedTasks };
};
